import { FC } from 'react';
import { ExpectationResultEnum } from '../../../types/tecton_proto/dataobs/validation';
import { Badge } from '@lithos';

const ResultBadge: FC<{ result: ExpectationResultEnum }> = ({ result }) => {
  if (result === ExpectationResultEnum.RESULT_PASSED) {
    return <Badge color={'green'} label={'Passed'} size="s" />;
  }

  if (result === ExpectationResultEnum.RESULT_FAILED) {
    return <Badge color={'red'} data-testid="failed-badge" label={'Failed'} size="s" />;
  }

  return <Badge color={'yellow'} data-testid="error-badge" label={'Error'} size="s" />;
};

export default ResultBadge;
